
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _4049SrxXaCB_NZioPdNISSxpID2uA_y0hHtE3WzbNo_lm0Meta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/404.vue?macro=true";
import { default as indexknJ9VWqELQdC9ChHgOItUCpDB4ZgneHkVfeuxRRmAKYMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/index.vue?macro=true";
import { default as tasksbOO2XPHjmrMf6Zdwgcexv24ZLZxDMr6eBqs2daI9KiUMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/tasks.vue?macro=true";
import { default as profileLREky5L27Y5BV4ffcxQgYKuxWcAhKXG7wa8eZroOCkYMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/profile.vue?macro=true";
import { default as invoicesaKHMa_kjSziqy3rzHEBdP7FdaPB2hoFTWSh3zVcEnPgMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/invoices.vue?macro=true";
import { default as _91_46_46_46slug_93Df4Cz0N7iXEagpNiZxg_6WhSFeNZDfIwQh22uup1Wd0Meta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/[...slug].vue?macro=true";
import { default as indexvgqSjHntEnymD4F8VOhcbvSj1JwApLD7X2_zmD2V_2wMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/format/index.vue?macro=true";
import { default as index9XtPeKZZOVBci0a1zzp_pOk3ew29vCJkEkGqybISmRcMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/index.vue?macro=true";
import { default as _91slug_93FnWQKxVbq3zwBMYWuFn9dV6jEHbie0r6PDMYbD9xTrAMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/format/[slug].vue?macro=true";
import { default as indexW_qTEEFQYEVNg_fGlX2ZYKI5roMtiwDEDoxW13D9VXgMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/pricing/index.vue?macro=true";
import { default as indexhg3BVBn1315uAF8s5d9ck9QSn5LsV6xSYwz6uKkRINUMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/support/index.vue?macro=true";
import { default as indexV3cOwHHisWzoO9sldHhn_zxST_GngNQ9X7JYExOBGEIMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/download/index.vue?macro=true";
import { default as _91_46_46_46slug_932zrd3l_PMXqjiMUPfx_Z1FA_GJgJo9j8gMdyguwjIiwMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/admin/[...slug].vue?macro=true";
import { default as indexAQSzZoiFaTph_0gRJazd7qtAR35j_f9QpXdtXACCq3oMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/admin/pop/index.vue?macro=true";
import { default as _91id_93tuXmg2yaH2FByc_pYJdI4m8t5TL1iNg7v33qqnByE_kMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/admin/test/[id].vue?macro=true";
import { default as indexctzxSzfD9k30DSCMFR3Dz8SQwnU13CohRP7BQekD7twMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/models/index.vue?macro=true";
import { default as earn_45creditsGZ05iikVt3bWD9ItrL175zn4AAx_bylUe6pCWG2KkzEMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/earn-credits.vue?macro=true";
import { default as plan_45creditspA7y5yqRzYZsQN0vDiHlHLYeO2VxzVlruNaxDX5DwS4Meta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/plan-credits.vue?macro=true";
import { default as indexe8kF3ria_YSNNYHAeb8FAeCCd_RSeBrvfrZpF9EV30AMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/admin/test/index.vue?macro=true";
import { default as indexRUkhnKYRQt5JV6OGSKQ8Bjwqvvo2W5P1VoHRXGHs_j8Meta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/effects/index.vue?macro=true";
import { default as indexBDNbyK_RaTCAMQsbF82qu1g7GDKzSFn19Nim_AFsw3kMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/index.vue?macro=true";
import { default as refer_45a_45friendwZjeDIUVxkZluAQF24tdUwDDbomSlY8kaQ_mtujCJ0QMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/refer-a-friend.vue?macro=true";
import { default as contact_45usghY7NTHdk4vDWQp4t5u_0MjnvIeQuMXzU8z2VBUgdGAMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/contact-us.vue?macro=true";
import { default as _91_46_46_46slug_93vjadSxRNpQ6iC_JjykjYGf9ntI53e_cdXdh_eu0enZEMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/models/[...slug].vue?macro=true";
import { default as terms0e6TRZG4Av7LAoPrAcA_lAtVmlotA0mLCvOv2pI7vCEMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/trust/terms.vue?macro=true";
import { default as _91_46_46_46slug_93n0UAKFdmZFYoL2qqiWnNe1btRHyHYLRWY3dbrETj_wAMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/effects/[...slug].vue?macro=true";
import { default as indexiIfsq6XE3FQySH2CUdLjLMTrfUemTvUtVq0REG_5PP4Meta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/apple-callback/index.vue?macro=true";
import { default as _91_46_46_46slug_93smCjyVw6y_yhu6Z4S6_snIwPqWBlLZXYEiG79yj4MSYMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/[...slug].vue?macro=true";
import { default as index9MJJ4aaKbNLp8hMpetIaMIVXapCwmtc_NjW5QQYYb2gMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/reset-password/index.vue?macro=true";
import { default as privacyMkchwInd4kyQfonPv7upg65cJUifV7kdxAnQKGsdS3oMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/trust/privacy.vue?macro=true";
import { default as verify8vB_HwHCuDz7p9Lhb8BDZxIq5CIVWcCWRZQ9MgCAWUYMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/reset-password/verify.vue?macro=true";
import { default as indexM1YD2aT0qwdgKmii_T4EPnDm0mFUmlsLlqN6PCkrThYMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/audio/index.vue?macro=true";
import { default as indexeq01L29aQcyWzTDWLw6gDAPtc0jcnPhEl871tSJ9l9MMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/image/index.vue?macro=true";
import { default as indexvc3OKg4KHQRTyDJKw6XB6K4XpI8MtdXefsJojQvIXAEMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/video/index.vue?macro=true";
import { default as successXty_TMKbE0GUWFFH6efk10aVxuD5DfsPgfiyJvWk5FYMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/reset-password/success.vue?macro=true";
import { default as workflow_45debugAmZor5UlOIm2GgRrRg167hq4kVwcKQYi5c7q27xC_w4Meta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/effects/workflow-debug.vue?macro=true";
import { default as converterXEs6gn1PUZ7WgUlXyNRxPCdk9RQMJ9yYh1YLLPndZ7UMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/image/converter.vue?macro=true";
import { default as refund_45policy67X9sogMZnAqfo2uAYm5DuljVeTLgkNRVgf43Zr_O6oMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/trust/refund-policy.vue?macro=true";
import { default as compressor689CizRoQU0KuHxtCOk8xPnKfziW9m_hJ3AMxgnnIA0Meta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/image/compressor.vue?macro=true";
import { default as component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c } from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexknJ9VWqELQdC9ChHgOItUCpDB4ZgneHkVfeuxRRmAKYMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/index.vue")
  },
  {
    name: "my-tasks",
    path: "/my/tasks",
    meta: tasksbOO2XPHjmrMf6Zdwgcexv24ZLZxDMr6eBqs2daI9KiUMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/tasks.vue")
  },
  {
    name: "my-profile",
    path: "/my/profile",
    meta: profileLREky5L27Y5BV4ffcxQgYKuxWcAhKXG7wa8eZroOCkYMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/profile.vue")
  },
  {
    name: "my-invoices",
    path: "/my/invoices",
    meta: invoicesaKHMa_kjSziqy3rzHEBdP7FdaPB2hoFTWSh3zVcEnPgMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/invoices.vue")
  },
  {
    name: "ai-slug",
    path: "/ai/:slug(.*)*",
    meta: _91_46_46_46slug_93Df4Cz0N7iXEagpNiZxg_6WhSFeNZDfIwQh22uup1Wd0Meta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/[...slug].vue")
  },
  {
    name: "format",
    path: "/format",
    meta: indexvgqSjHntEnymD4F8VOhcbvSj1JwApLD7X2_zmD2V_2wMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/format/index.vue")
  },
  {
    name: "company",
    path: "/company",
    meta: index9XtPeKZZOVBci0a1zzp_pOk3ew29vCJkEkGqybISmRcMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/index.vue")
  },
  {
    name: "format-slug",
    path: "/format/:slug()",
    meta: _91slug_93FnWQKxVbq3zwBMYWuFn9dV6jEHbie0r6PDMYbD9xTrAMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/format/[slug].vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: indexW_qTEEFQYEVNg_fGlX2ZYKI5roMtiwDEDoxW13D9VXgMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/pricing/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexhg3BVBn1315uAF8s5d9ck9QSn5LsV6xSYwz6uKkRINUMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/support/index.vue")
  },
  {
    name: "download",
    path: "/download",
    meta: indexV3cOwHHisWzoO9sldHhn_zxST_GngNQ9X7JYExOBGEIMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/download/index.vue")
  },
  {
    name: "admin-slug",
    path: "/admin/:slug(.*)*",
    meta: _91_46_46_46slug_932zrd3l_PMXqjiMUPfx_Z1FA_GJgJo9j8gMdyguwjIiwMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/admin/[...slug].vue")
  },
  {
    name: "admin-pop",
    path: "/admin/pop",
    meta: indexAQSzZoiFaTph_0gRJazd7qtAR35j_f9QpXdtXACCq3oMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/admin/pop/index.vue")
  },
  {
    name: "admin-test-id",
    path: "/admin/test/:id()",
    meta: _91id_93tuXmg2yaH2FByc_pYJdI4m8t5TL1iNg7v33qqnByE_kMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/admin/test/[id].vue")
  },
  {
    name: "ai-models",
    path: "/ai/models",
    meta: indexctzxSzfD9k30DSCMFR3Dz8SQwnU13CohRP7BQekD7twMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/models/index.vue")
  },
  {
    name: "my-earn-credits",
    path: "/my/earn-credits",
    meta: earn_45creditsGZ05iikVt3bWD9ItrL175zn4AAx_bylUe6pCWG2KkzEMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/earn-credits.vue")
  },
  {
    name: "my-plan-credits",
    path: "/my/plan-credits",
    meta: plan_45creditspA7y5yqRzYZsQN0vDiHlHLYeO2VxzVlruNaxDX5DwS4Meta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/plan-credits.vue")
  },
  {
    name: "admin-test",
    path: "/admin/test",
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/admin/test/index.vue")
  },
  {
    name: "ai-effects",
    path: "/ai/effects",
    meta: indexRUkhnKYRQt5JV6OGSKQ8Bjwqvvo2W5P1VoHRXGHs_j8Meta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/effects/index.vue")
  },
  {
    name: "free-tools",
    path: "/free-tools",
    meta: indexBDNbyK_RaTCAMQsbF82qu1g7GDKzSFn19Nim_AFsw3kMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/index.vue")
  },
  {
    name: "my-refer-a-friend",
    path: "/my/refer-a-friend",
    meta: refer_45a_45friendwZjeDIUVxkZluAQF24tdUwDDbomSlY8kaQ_mtujCJ0QMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/my/refer-a-friend.vue")
  },
  {
    name: "company-contact-us",
    path: "/company/contact-us",
    meta: contact_45usghY7NTHdk4vDWQp4t5u_0MjnvIeQuMXzU8z2VBUgdGAMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/contact-us.vue")
  },
  {
    name: "ai-models-slug",
    path: "/ai/models/:slug(.*)*",
    meta: _91_46_46_46slug_93vjadSxRNpQ6iC_JjykjYGf9ntI53e_cdXdh_eu0enZEMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/models/[...slug].vue")
  },
  {
    name: "company-trust-terms",
    path: "/company/trust/terms",
    meta: terms0e6TRZG4Av7LAoPrAcA_lAtVmlotA0mLCvOv2pI7vCEMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/trust/terms.vue")
  },
  {
    name: "ai-effects-slug",
    path: "/ai/effects/:slug(.*)*",
    meta: _91_46_46_46slug_93n0UAKFdmZFYoL2qqiWnNe1btRHyHYLRWY3dbrETj_wAMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/effects/[...slug].vue")
  },
  {
    name: "apple-callback",
    path: "/apple-callback",
    meta: indexiIfsq6XE3FQySH2CUdLjLMTrfUemTvUtVq0REG_5PP4Meta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/apple-callback/index.vue")
  },
  {
    name: "free-tools-slug",
    path: "/free-tools/:slug(.*)*",
    meta: _91_46_46_46slug_93smCjyVw6y_yhu6Z4S6_snIwPqWBlLZXYEiG79yj4MSYMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/[...slug].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: index9MJJ4aaKbNLp8hMpetIaMIVXapCwmtc_NjW5QQYYb2gMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/reset-password/index.vue")
  },
  {
    name: "company-trust-privacy",
    path: "/company/trust/privacy",
    meta: privacyMkchwInd4kyQfonPv7upg65cJUifV7kdxAnQKGsdS3oMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/trust/privacy.vue")
  },
  {
    name: "reset-password-verify",
    path: "/reset-password/verify",
    meta: verify8vB_HwHCuDz7p9Lhb8BDZxIq5CIVWcCWRZQ9MgCAWUYMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/reset-password/verify.vue")
  },
  {
    name: "free-tools-audio",
    path: "/free-tools/audio",
    meta: indexM1YD2aT0qwdgKmii_T4EPnDm0mFUmlsLlqN6PCkrThYMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/audio/index.vue")
  },
  {
    name: "free-tools-image",
    path: "/free-tools/image",
    meta: indexeq01L29aQcyWzTDWLw6gDAPtc0jcnPhEl871tSJ9l9MMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/image/index.vue")
  },
  {
    name: "free-tools-video",
    path: "/free-tools/video",
    meta: indexvc3OKg4KHQRTyDJKw6XB6K4XpI8MtdXefsJojQvIXAEMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/video/index.vue")
  },
  {
    name: "reset-password-success",
    path: "/reset-password/success",
    meta: successXty_TMKbE0GUWFFH6efk10aVxuD5DfsPgfiyJvWk5FYMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/reset-password/success.vue")
  },
  {
    name: "ai-effects-workflow-debug",
    path: "/ai/effects/workflow-debug",
    meta: workflow_45debugAmZor5UlOIm2GgRrRg167hq4kVwcKQYi5c7q27xC_w4Meta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/ai/effects/workflow-debug.vue")
  },
  {
    name: "free-tools-image-converter",
    path: "/free-tools/image/converter",
    meta: converterXEs6gn1PUZ7WgUlXyNRxPCdk9RQMJ9yYh1YLLPndZ7UMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/image/converter.vue")
  },
  {
    name: "company-trust-refund-policy",
    path: "/company/trust/refund-policy",
    meta: refund_45policy67X9sogMZnAqfo2uAYm5DuljVeTLgkNRVgf43Zr_O6oMeta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/company/trust/refund-policy.vue")
  },
  {
    name: "free-tools-image-compressor",
    path: "/free-tools/image/compressor",
    meta: compressor689CizRoQU0KuHxtCOk8xPnKfziW9m_hJ3AMxgnnIA0Meta || {},
    component: () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/pages/free-tools/image/compressor.vue")
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/trust/privacy/",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/trust/terms/",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/trust/",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/help/",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/help",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/sign-in/:pathMatch(.*)",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/sign-in",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/sign-up/:pathMatch(.*)",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/sign-up",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/help/contact-us/",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/help/contact-us",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/app/:pathMatch(.*)",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/app",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/my/dashboard/:pathMatch(.*)",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/my/dashboard",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/my/orders/:pathMatch(.*)",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  },
  {
    name: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55cMeta?.name,
    path: "/my/orders",
    component: component_45stubkP5PwEueb64JPpLSj_vuNlOk9pOcDplwHfjbePvO55c
  }
]